import PropellerLogo from "../../images/propeller.svg";

export default function Header() {
  return (
    <header className="flex items-center h-[74px] p-l border-b border-separator-light">
      <div className="w-full max-w-container mx-auto">
        <img
          src={PropellerLogo}
          alt="Propeller logo"
          width="138"
          height="26"
        />
      </div>
    </header>
  );
}
